import { render, staticRenderFns } from "./QuickBetPanel.vue?vue&type=template&id=48b0f8b8&scoped=true"
import script from "./QuickBetPanel.vue?vue&type=script&lang=js"
export * from "./QuickBetPanel.vue?vue&type=script&lang=js"
import style0 from "./QuickBetPanel.vue?vue&type=style&index=0&id=48b0f8b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b0f8b8",
  null
  
)

export default component.exports